<template>

    <div>
        <div class="wrapper chart-css" v-if="!showImage">
            <div class="bars" :style="{height: `${height}px`}">
                <template v-for="(value, i) in values">
                    <div class="box" :key="i" :style="{height: `${vPixels(value)}px`}"></div>
                    <div v-if="markers.indexOf(i) >= 0" :key="-i-1" style="position: relative;">
                        <div class="v-line" :style="{height: `${height}px`, top: `${-height}px`, left: `-5.5px`}"></div>
                    </div>
                </template>
            </div>
        </div>
        <img :src="dataurl" v-if="showImage" class="bar-chart" />
    </div>
</template>


<script>
import html2canvas from 'html2canvas'
export default {
    props: {
        values: {
            required: true,
            validator: value => Array.isArray(value) && value.every(v => typeof v == 'number'),
        },
        markers: {
            default: [],
            validator: value => Array.isArray(value) && value.every(v => typeof v == 'number'),
        },
        height: {
            type: Number,
            default: 1.5,
        },
        forPrint: {
            default: false
        }
    },
    data() {
        return {
            dataurl: "",
            showImage: false
        }
    },
    mounted() {
        if (this.forPrint) {
            this.getDataUrl(this.$el.getElementsByClassName('chart-css')[0])
        }

    },
    computed: {
        maxValue() {
            return Math.max(...this.values)
        }
    },
    methods: {
        vPixels(value) {
            return this.height * value
        },
        async getDataUrl(el) {
            const canvas = await html2canvas(el).catch(e => { console.log(e) })
            this.dataurl = canvas.toDataURL()
            this.showImage = true
        }
    }
}
</script>


<style lang="scss" scoped>
.wrapper {
  display: inline-block;
  padding: 0.25em;
  //   background-color: white;
  //   box-shadow: 0 0 4pt rgba(black, 0.5);
}

.bars {
  display: flex;
  padding: 0 1px;
  align-items: flex-end;
  border-width: 0 0 1px 0;
  border-color: gray;
  border-style: solid;
}

.box {
  -webkit-print-color-adjust: exact;
  background-color: rgba(blue, 0.75) !important;
  display: inline-block;
  width: 8px;
  margin: 0 1px;
}
img.bar-chart {
  width: 70px;
  height: 20px;
}
.v-line {
  -webkit-print-color-adjust: exact;
  background-color: red !important;
  width: 3px;
  position: absolute;
  border: 1px solid red;
}
</style>